// FAQ Page Translations
export const faqTranslations = {
  en: {
    // Page Header
    pageTitle: 'Frequently Asked Questions',
    pageSubtitle: 'Find answers to common questions about our services, delivery, payment, and support.',

    // FAQ Sections
    generalInformation: 'General Information',
    deliveryActivation: 'Delivery & Activation',
    accountIssuesSupport: 'Account Issues & Support',
    paymentPricing: 'Payment & Pricing',
    streamingPlatforms: 'Streaming Platforms',
    aiProfessionalTools: 'AI & Professional Tools',
    educationPlatforms: 'Education Platforms',

    // General Information FAQs
    q1: 'What services does your platform provide?',
    a1: 'We provide premium digital subscriptions, including streaming platforms, AI tools, design & editing software, educational platforms with certificates, VPNs, and other professional digital tools — all in one place.',

    q2: 'Are you a trusted and reliable service provider?',
    a2: 'Yes. We have served 10,000+ customers worldwide and focus on long-term reliability, structured delivery, and post-delivery support.',

    q3: 'Are these original premium subscriptions?',
    a3: 'Yes. All subscriptions are premium-level plans activated using secure and controlled methods.',

    q4: 'Are your services available worldwide?',
    a4: "Yes. Our services are available globally, subject to the official platform's regional availability.",

    q5: 'Do I need a VPN to use the subscriptions?',
    a5: 'No. VPN is not required. All subscriptions work normally in supported countries.',

    // Delivery & Activation FAQs
    q6: 'How long does delivery take after payment?',
    a6: 'Once payment is confirmed, delivery is completed within 24 hours. In most cases, it is faster.',

    q7: 'Will the subscription be activated on my own email?',
    a7: 'Yes. Subscriptions can be activated on your own email. We recommend using a fresh email and password for smooth activation.',

    q8: "Can you provide an email if I don't want to use my own?",
    a8: 'Yes. We can provide a dedicated email and password. You can change the password after delivery for security.',

    q9: 'Why do you recommend using a fresh email address?',
    a9: 'A fresh email avoids login conflicts, security issues, and previous platform restrictions.',

    // Account Issues & Support FAQs
    q10: 'What if my subscription stops working or gets blocked?',
    a10: 'If an issue occurs, report it within 24 hours. Our team will review and resolve it within the same timeframe according to service terms.',

    q11: 'Do you provide customer support after delivery?',
    a11: 'Yes. Dedicated WhatsApp support is available for all active subscriptions.',

    // Payment & Pricing FAQs
    q12: 'What payment methods do you accept?',
    a12: 'We accept Revolut, PayPal, Payoneer, Binance, Western Union, and Xoom. Availability may vary by country.',

    q13: 'When does the delivery time officially start?',
    a13: 'Delivery time starts after payment confirmation.',

    q14: 'Do you offer discounts?',
    a14: 'Yes. Special discounts are available for bulk purchases and long-term subscriptions.',

    // Streaming Platforms FAQs
    q15: 'Do you offer Netflix subscriptions?',
    a15: 'Yes. Netflix subscriptions are available in monthly and yearly plans, depending on availability.',

    q16: 'How many devices can I use with streaming subscriptions?',
    a16: 'You can log in on multiple devices. Simultaneous streaming depends on the plan and platform policies.',

    // AI & Professional Tools FAQs
    q17: 'Do you offer ChatGPT Plus and ChatGPT Pro?',
    a17: 'Yes. Both ChatGPT Plus and ChatGPT Pro plans are available.',

    q18: 'Is Gemini Pro available as a yearly subscription?',
    a18: 'Yes. Gemini Pro is available as a one-year plan and is activated on your email or a provided email.',

    q19: 'Do you offer ElevenLabs subscriptions?',
    a19: 'Yes. ElevenLabs plans are available with credit options ranging from 100,000 to 1,000,000 credits.',

    // Education Platforms FAQs
    q20: 'Do you offer Coursera subscriptions with certificates?',
    a20: 'Yes. Coursera yearly subscriptions are available and include official, verifiable certificates issued by the platform.',

    // Still Have Questions Section
    stillHaveQuestions: 'Still Have Questions?',
    contactSupport: 'Contact our support team via WhatsApp or email. We\'re happy to help!',
    chatWhatsApp: 'Chat on WhatsApp',
    emailUs: 'Email Us',

    // Quick Navigation
    quickNavigation: 'Quick Navigation',
    contactUs: 'Contact Us',
    contactUsDesc: 'Need more help? Reach out to our support team directly.',
    browseProducts: 'Browse Products',
    browseProductsDesc: 'Explore all our premium subscriptions and services.',
    backToHome: 'Back to Home',
    backToHomeDesc: 'Discover featured products and special offers.',
  },

  fr: {
    // Page Header
    pageTitle: 'Questions Fréquemment Posées',
    pageSubtitle: 'Trouvez des réponses aux questions courantes sur nos services, la livraison, le paiement et le support.',

    // FAQ Sections
    generalInformation: 'Informations Générales',
    deliveryActivation: 'Livraison et Activation',
    accountIssuesSupport: 'Problèmes de Compte et Support',
    paymentPricing: 'Paiement et Tarification',
    streamingPlatforms: 'Plateformes de Streaming',
    aiProfessionalTools: 'Outils IA et Professionnels',
    educationPlatforms: 'Plateformes Éducatives',

    // General Information FAQs
    q1: 'Quels services votre plateforme propose-t-elle?',
    a1: 'Nous proposons des abonnements numériques premium, notamment des plateformes de streaming, des outils IA, des logiciels de conception et d\'édition, des plateformes éducatives avec certificats, des VPN et d\'autres outils numériques professionnels — tout en un seul endroit.',

    q2: 'Êtes-vous un fournisseur de services fiable et digne de confiance?',
    a2: 'Oui. Nous avons servi plus de 10 000 clients dans le monde et nous nous concentrons sur la fiabilité à long terme, la livraison structurée et le support post-livraison.',

    q3: 'S\'agit-il d\'abonnements premium originaux?',
    a3: 'Oui. Tous les abonnements sont des forfaits de niveau premium activés à l\'aide de méthodes sécurisées et contrôlées.',

    q4: 'Vos services sont-ils disponibles dans le monde entier?',
    a4: 'Oui. Nos services sont disponibles à l\'échelle mondiale, sous réserve de la disponibilité régionale de la plateforme officielle.',

    q5: 'Ai-je besoin d\'un VPN pour utiliser les abonnements?',
    a5: 'Non. Un VPN n\'est pas nécessaire. Tous les abonnements fonctionnent normalement dans les pays pris en charge.',

    // Delivery & Activation FAQs
    q6: 'Combien de temps prend la livraison après le paiement?',
    a6: 'Une fois le paiement confirmé, la livraison est effectuée dans les 24 heures. Dans la plupart des cas, c\'est plus rapide.',

    q7: 'L\'abonnement sera-t-il activé sur mon propre email?',
    a7: 'Oui. Les abonnements peuvent être activés sur votre propre email. Nous recommandons d\'utiliser une adresse email et un mot de passe frais pour une activation en douceur.',

    q8: 'Pouvez-vous fournir un email si je ne veux pas utiliser le mien?',
    a8: 'Oui. Nous pouvons fournir une adresse email et un mot de passe dédiés. Vous pouvez modifier le mot de passe après la livraison pour la sécurité.',

    q9: 'Pourquoi recommandez-vous d\'utiliser une adresse email récente?',
    a9: 'Une adresse email récente évite les conflits de connexion, les problèmes de sécurité et les restrictions précédentes de la plateforme.',

    // Account Issues & Support FAQs
    q10: 'Que se passe-t-il si mon abonnement cesse de fonctionner ou est bloqué?',
    a10: 'Si un problème survient, signalez-le dans les 24 heures. Notre équipe l\'examinera et le résoudra dans le même délai selon les conditions de service.',

    q11: 'Proposez-vous un support client après la livraison?',
    a11: 'Oui. Un support WhatsApp dédié est disponible pour tous les abonnements actifs.',

    // Payment & Pricing FAQs
    q12: 'Quelles méthodes de paiement acceptez-vous?',
    a12: 'Nous acceptons Revolut, PayPal, Payoneer, Binance, Western Union et Xoom. La disponibilité peut varier selon le pays.',

    q13: 'Quand la livraison commence-t-elle officiellement?',
    a13: 'La livraison commence après la confirmation du paiement.',

    q14: 'Proposez-vous des remises?',
    a14: 'Oui. Des réductions spéciales sont disponibles pour les achats en gros et les abonnements à long terme.',

    // Streaming Platforms FAQs
    q15: 'Proposez-vous des abonnements Netflix?',
    a15: 'Oui. Les abonnements Netflix sont disponibles en forfaits mensuels et annuels, selon la disponibilité.',

    q16: 'Combien d\'appareils puis-je utiliser avec les abonnements de streaming?',
    a16: 'Vous pouvez vous connecter sur plusieurs appareils. La lecture simultanée dépend du forfait et des politiques de la plateforme.',

    // AI & Professional Tools FAQs
    q17: 'Proposez-vous ChatGPT Plus et ChatGPT Pro?',
    a17: 'Oui. Les forfaits ChatGPT Plus et ChatGPT Pro sont disponibles.',

    q18: 'Gemini Pro est-il disponible en tant qu\'abonnement annuel?',
    a18: 'Oui. Gemini Pro est disponible en tant que forfait d\'un an et est activé sur votre email ou un email fourni.',

    q19: 'Proposez-vous des abonnements ElevenLabs?',
    a19: 'Oui. Les forfaits ElevenLabs sont disponibles avec des options de crédit allant de 100 000 à 1 000 000 de crédits.',

    // Education Platforms FAQs
    q20: 'Proposez-vous des abonnements Coursera avec certificats?',
    a20: 'Oui. Les abonnements annuels Coursera sont disponibles et incluent les certificats officiels et vérifiables émis par la plateforme.',

    // Still Have Questions Section
    stillHaveQuestions: 'Vous Avez d\'Autres Questions?',
    contactSupport: 'Contactez notre équipe d\'assistance via WhatsApp ou email. Nous sommes heureux de vous aider!',
    chatWhatsApp: 'Discuter sur WhatsApp',
    emailUs: 'Nous Envoyer un Email',

    // Quick Navigation
    quickNavigation: 'Navigation Rapide',
    contactUs: 'Nous Contacter',
    contactUsDesc: 'Besoin d\'aide? Contactez directement notre équipe d\'assistance.',
    browseProducts: 'Parcourir les Produits',
    browseProductsDesc: 'Explorez tous nos abonnements et services premium.',
    backToHome: 'Retour à l\'Accueil',
    backToHomeDesc: 'Découvrez les produits en vedette et les offres spéciales.',
  },
};

export const useFaqTranslations = (language = 'en') => {
  return faqTranslations[language] || faqTranslations['en'];
};
